import { CoreLogService } from "../log.service";

export interface IDiagnostic {
  isLocationEnabled(): Promise<boolean>;
  isLocationAuthorized(): Promise<boolean>;
  isLocationAvailable(): Promise<boolean>;
}

export class Diagnostic implements IDiagnostic {

  constructor(private _coreLogService: CoreLogService) { }

  public isLocationEnabled(): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      try {
        cordova.plugins["diagnostic"].isLocationEnabled((response) => {
          resolve(response);
        }, (error) => {
          me._coreLogService.error("comEnvironmentDiagnostic.isLocationEnabled", "callback error", error);
          reject();
        })
      } catch (error) {
        me._coreLogService.error("comEnvironmentDiagnostic.isLocationEnabled", "catch error", error);
        reject(error);
      }
    });
  }

  public isLocationAuthorized(): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      try {
        cordova.plugins["diagnostic"].isLocationAuthorized((response) => {
          resolve(response);
        }, (error) => {
          me._coreLogService.error("comEnvironmentDiagnostic.isLocationAuthorized", "callback error", error);
          reject(error);
        })
      } catch (error) {
        me._coreLogService.error("comEnvironmentDiagnostic.isLocationAuthorized", "catch error", error);
        reject(error);
      }
    });
  }

  public isLocationAvailable(): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      try {
        cordova.plugins["diagnostic"].isLocationAvailable((response) => {
          resolve(response);
        }, (error) => {
          me._coreLogService.error("comEnvironmentDiagnostic.isLocationAvailable", "callback error", error);
          reject(error);
        })
      } catch (error) {
        me._coreLogService.error("comEnvironmentDiagnostic.isLocationAvailable", "catch error", error);
        reject(error);
      }
    });
  }

}